/* eslint-disable */

import { appActions, store } from "../store";
import { globalVars } from "../libs/global-vars";
import axios from "axios";

//Logbox 테스트
import { LogBox as LogBoxPrd } from '../logboxLibs/logbox-prod-event-tmap-evcharge';
import { LogBox as LogBoxStg } from '../logboxLibs/logbox-stg-event-tmap-evcharge';
let logBox = process.env.REACT_APP_BUILD_ENV === 'PRD' ? LogBoxPrd() : LogBoxStg();
import dayjs from './dayjs';
import { browserName, fullBrowserVersion, isIOS } from "react-device-detect";

//Mixpanel
import mixpanelBrowser from 'mixpanel-browser/src/loaders/loader-module-core';

// EV Collector의 고정 수집 계약이며 이 어댑터에서만 사용합니다.
const COLLECTOR_APP_ID = 'tmap';
const COLLECTOR_SERVICE_ID = 'ev';
// 브라우저 SPA의 모듈 인스턴스마다 SDK를 한 번 초기화합니다. SSR에서는 사용하지 않습니다.
// 테스트는 jest.resetModules()로 이 모듈과 SDK mock을 함께 새로 로드합니다.
let isCollectorInitialized = false;

const logbox = (pageId, actionId) => {
  // 로그박스 날짜
  const timeformat = dayjs().format('YYYYMMDDHHmmssSSS');

  // ##### set common
  logBox.setIp("127.0.0.1")
    .setApp_version("1.0")
    .setSession_id(store.getState().app.sessionId)
    .setSub_session_id(store.getState().app.subSessionId)
    .setLocal_time(timeformat);

  // ##### set env
  logBox.setOs_name(globalVars.osName)
    .setOs_version(globalVars.osVersion)//--
    .setResolution(screen.width + "*" + screen.height)//window
    .setScreen_width(screen.width)//--
    .setScreen_height(screen.height)//--
    .setCarrier_name("")// 통신사
    .setNetwork_type(globalVars.connectionType)// android 정상 작동 ios 백화 현상
    .setManufacturer(globalVars.manufacturer)// 제조사
    .setDevice_id("")// X
    .setDevice_model(globalVars.isAndroid ? globalVars.splitDeviceModel ? globalVars.splitDeviceModel[2] : "Android" : globalVars.deviceModel) //--globalVars.deviceModel
    .setBrowser_name(browserName) //--
    .setBrowser_version(fullBrowserVersion)// --
    .setReferrer("")
    .setLanguage_code(globalVars.languageCode) //--
    .setUrl("")// X
    .setDocument_title("");// --

  // ##### set meta
  logBox.setPage_id(pageId)
    .setPage_type("WEB")
    .setSection_id("")
    .setAction_id(actionId);

  axios.get(logBox.getTlaURIEncode())
    .then(function (response: any) {
      const test = response.data
    });
}

/**
 * 기존 이벤트명을 유지하면서 Log Collector로 전송합니다.
 * @param actionId `service:/page:action` 형식. action 내부의 콜론은 보존합니다.
 * @param properties 추가 이벤트 속성. 고정 Collector 식별자는 변경할 수 없습니다.
 * 토큰 또는 수집 주소가 없으면 전송을 생략하며, page-only 이벤트도 허용합니다.
 */
const mixpanel = (actionId: string, properties?: Record<string, unknown>) => {
  const token = window.__RUNTIME_CONFIG__?.logCollectorToken;
  const endpoint = process.env.REACT_APP_LOG_COLLECTOR_ENDPOINT;
  if (!token || !endpoint) return;

  const [, pageId, ...actionParts] = actionId.split(':');
  const parsedActionId = actionParts.join(':');
  const collectorProperties = {
    ...properties,
    app_id: COLLECTOR_APP_ID,
    service_id: COLLECTOR_SERVICE_ID,
    ...(pageId && { page_id: pageId }),
    ...(parsedActionId && { action_id: parsedActionId }),
  };
  
  if (!isCollectorInitialized) {
    mixpanelBrowser.init(token, {
      debug: process.env.REACT_APP_BUILD_ENV !== 'PRD',
      api_host: endpoint,
      api_method: 'POST',
      api_payload_format: 'base64',
    });
    isCollectorInitialized = true;
  }
  // 최신 euk를 전달합니다. SDK는 distinct_id가 바뀔 때만 $identify 이벤트를 전송합니다.
  mixpanelBrowser.identify(store.getState().app.euk);
  
  mixpanelBrowser.track(actionId, collectorProperties);
}

export { logbox, mixpanel };
